export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/patient/notifications/index.js